import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const api = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/plan_groups?" + qstr);
  },
  update(id, inputs) {
    return api.put("/plan_groups/" + id, inputs);
  },
  create(inputs) {
    return api.post("/plan_groups", inputs);
  },
  delete(id) {
    return api.delete("/plan_groups/" + id);
  },
  active(id, inputs) {
    return api.put(`/plan_groups/${id}/active`, inputs);
  },
  find(id) {
    return api.get("/plan_groups/" + id);
  },
};
